/** Prefixes https:// to a website typed without a scheme. */
export const withHttps = <T extends { website?: string | null }>(
  values: T,
): T =>
  values.website && !values.website.startsWith("http")
    ? { ...values, website: `https://${values.website}` }
    : values;

/**
 * A company's one-line description: "sector · city" with whichever of the
 * two is known, or null when neither is (callers fall back to something
 * else, such as the number of contacts).
 */
export const companyPlace = (
  company: { sector?: string | null; city?: string | null },
  sectors: readonly { value: string; label: string }[],
): string | null => {
  const sector = sectors.find((item) => item.value === company.sector)?.label;
  const parts = [sector, company.city?.trim()].filter(Boolean);
  return parts.length > 0 ? parts.join(" · ") : null;
};
